// extracted by mini-css-extract-plugin
export default {"root":"MoveToEditorTool_root__BAm+n","title":"MoveToEditorTool_title__2TJzJ"};